import request from '@/utils/request'

// 查询提前送货申请主单信息
export function getHeadData(applyCode) {
  return request({
    url: `/api/coop/coopDeliveryAdvanceApply/getHeadData/${applyCode}`,
    method: 'get'
  })
}

// 查询物料明细
export function materialDetailQuery(query) {
  return request({
    url: '/api/coop/coopDeliveryDueAdvanceDetail/pageQuery',
    method: 'get',
    params: query
  })
}

// 根据采购组获取采购专员
export function getPurEngineerId(obj) {
  return request({
    url: '/api/srm-base/struPurgrp/getPurEngineerByPurGrpList',
    method: 'post',
    data: obj
  })
}
